import { render, staticRenderFns } from "./TableCreate.vue?vue&type=template&id=b5368254&scoped=true&lang=pug"
import script from "./TableCreate.vue?vue&type=script&lang=js"
export * from "./TableCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5368254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5368254')) {
      api.createRecord('b5368254', component.options)
    } else {
      api.reload('b5368254', component.options)
    }
    module.hot.accept("./TableCreate.vue?vue&type=template&id=b5368254&scoped=true&lang=pug", function () {
      api.rerender('b5368254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/components/TableCreate.vue"
export default component.exports